import React, { FunctionComponent, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Paragraph } from '@vwfs-bronson/bronson-react'
import { isAUDI, isENVKVNew } from '../../services/common/utils'
import ENVKVShoppingCartCaption from '../ENVKV/ENVKVShoppingCartCaption'
import routes from '../../routes'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as customActions from '../../services/redux/features/custom.redux'
import { RootState } from '../../services/redux'

type Props = {
  storefrontData?: any
}

const ShoppingCartImageFooter: FunctionComponent<Props> = ({ storefrontData }) => {
  const { t } = useTranslation('form:shoppingCart')
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const transactionId = useSelector((state: RootState) => state.storefront?.data?.transaction?.id);
  const vehicleData = useMemo(() => storefrontData?.vehicleData, [storefrontData])

  const suffix = Array.from(
    t('form:shoppingCart:imageFooter:suffix:texts', {
      returnObjects: true,
    }) as Array<string>
  )

  // eslint-disable-next-line no-nested-ternary
  return isENVKVNew(vehicleData) ? (
    <ENVKVShoppingCartCaption
      onError={() => {
        dispatch(customActions.setErrorData({ url: window.location.href }));
        navigate(routes.errorPage)}
      }
      transactionId={transactionId}
      vehicleData={vehicleData}
    />
  // eslint-disable-next-line no-negated-condition
  ) : !isAUDI(storefrontData) ? (
    <>
      {suffix?.length > 0 &&
        suffix?.map((text: any) => (
          <Paragraph key={text} dangerouslySetInnerHTML={{ __html: text }} />
        ))}
    </>
  ) : <></>
}

export default ShoppingCartImageFooter
